const SVG_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
};

/** Значок «вилка и розетка» для кнопки «Подключить» (по мотивам Lucide `unplug`). */
export function PlugIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} {...SVG_PROPS}>
      <path d="m19 5 3-3" />
      <path d="m2 22 3-3" />
      <path d="M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" />
      <path d="M7.5 13.5 10 11" />
      <path d="M10.5 16.5 13 14" />
      <path d="m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z" />
    </svg>
  );
}

/**
 * Значок «вилка вставлена в розетку» — ключ уже привязан к устройству.
 * Две вилки, сомкнутые лицевыми панелями. Одна вилка: панель, два контакта,
 * корпус-полукруг с центром на оси вилки (концы — на кончиках контактов),
 * кабель из вершины. Вторая — та же, повёрнутая на 180°. Стиль как у PlugIcon.
 */
export function PluggedIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} {...SVG_PROPS}>
      <g>
        <path d="M8.01 5.71 18.19 15.89" />
        <path d="M9.35 7.05 11.76 4.65" />
        <path d="M16.85 14.55 19.25 12.14" />
        <path d="M11.76 4.65A5.30 5.30 0 0 1 19.25 12.14" />
        <path d="M19.25 4.65 22.29 1.61" />
      </g>
      <g transform="rotate(180 12 12)">
        <path d="M8.01 5.71 18.19 15.89" />
        <path d="M9.35 7.05 11.76 4.65" />
        <path d="M16.85 14.55 19.25 12.14" />
        <path d="M11.76 4.65A5.30 5.30 0 0 1 19.25 12.14" />
        <path d="M19.25 4.65 22.29 1.61" />
      </g>
    </svg>
  );
}
